import { get } from 'lodash-es'
import { toWorkflowData } from './toWorkflowData'

export const toBasicRegistrationData = (data: Json): TBasicStepWorkflowData => {
    return {
        inviter: get(data, 'inviter'),
        invitee: get(data, 'prefilledFormValues'),
        isEmailReadOnly: get(data, 'isEmailReadOnly'),
        workflow: toWorkflowData(data),
        workflowType: 'basic',
    }
}
